import axios from 'axios'

import { APP_ENV } from 'src/env'

export const ornaBackendClient = () => {
    const token = localStorage.getItem('access_token')
    const organizationId = localStorage.getItem('userOrganizationId')
    return axios.create({
        baseURL: `${APP_ENV.REACT_APP_ORNA_BACKEND_URL}`,
        headers: {
            ...(token &&
                APP_ENV.REACT_APP_STAGE !== 'cypress' && {
                    Authorization: `Bearer ${token}`,
                }),
            ...(organizationId &&
                APP_ENV.REACT_APP_STAGE !== 'cypress' && {
                    'X-User-Org': organizationId,
                }),
            ...(APP_ENV.REACT_APP_STAGE === 'cypress' && {
                'x-cypress-testing': APP_ENV.REACT_APP_CYPRESS_KEY,
            }),
        },
    })
}
